module.exports = "/assets/8364eab13b8a26b1b77918a6295cae7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/X9.png
// module id = 3106
// module chunks = 0